import {Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter} from '@angular/core';

import {Aviso} from '../aviso/aviso';
import {Alarma} from '../alarmas/alarma';
import {Usuario} from '../usuarios/usuario';
import {Sucursal} from '../sucursal/sucursal';

import {AvisoService} from './aviso.service';
import {UsuariosService} from '../usuarios/usuario.service';
import {PermisoService} from '../permiso/permiso.service';

declare var $: any;

@Component({
    selector: 'aviso',
    template: require('../../app/aviso/aviso.component.html'),
    styles: [require('../../app/aviso/aviso.component.css')]
})
export class AvisoComponent implements OnInit,OnChanges {

    @Input() alarma: Alarma;
    @Input() aviso: Aviso;
    @Input() sucursal: Sucursal;
    active: any;
    active2: any;
    deshabilitar: boolean;
    usuarios: Usuario[];
    usuario: string;
    @Output() permisos = new EventEmitter();


    constructor(private avisoService: AvisoService,
                private usuarioService: UsuariosService,
                private permisoService: PermisoService) {
    }

    ngOnInit() {
        this.alarma = new Alarma();
        this.aviso = new Aviso();
        this.active = true;
        this.active2 = true;

        //Pedir permisos
        this.permisoService.getPermiso("aviso").subscribe(permisos => {
            var respuesta = new Map();
            for (let permiso of permisos.tipoPermiso) {
                respuesta.set(permiso.descripcion, true);
            }
            this.permisos.emit({permisos: respuesta});
        })
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.alarma != undefined && this.sucursal != undefined && this.sucursal._id != undefined)
            this.usuarioService.getUsuarioBySucursal(this.sucursal._id)
                .subscribe((usuarios) => this.usuarios = usuarios);

        this.formatAviso();
    }

    formatAviso() {
        if (this.aviso != undefined && this.aviso._id != undefined) {
            let horaDesdeStr = this.aviso.horaDesde.toString();
            if (horaDesdeStr.indexOf(":") == -1) {
                if (horaDesdeStr.length == 3)
                    horaDesdeStr = "0".concat(horaDesdeStr);
                else if (horaDesdeStr.length == 2)
                    horaDesdeStr = "00".concat(horaDesdeStr);
                else if (horaDesdeStr.length == 1)
                    horaDesdeStr = "000".concat(horaDesdeStr);
                this.aviso.horaDesde = horaDesdeStr.slice(0, 2) + ":" + horaDesdeStr.slice(2);
            }
            let horaHastaStr = this.aviso.horaHasta.toString();
            if (horaHastaStr.indexOf(":") == -1) {
                if (horaHastaStr.length == 3)
                    horaHastaStr = "0".concat(horaHastaStr);
                else if (horaHastaStr.length == 2)
                    horaHastaStr = "00".concat(horaHastaStr);
                if (horaHastaStr.length == 1)
                    horaHastaStr = "000".concat(horaHastaStr);
                this.aviso.horaHasta = horaHastaStr.slice(0, 2) + ":" + horaHastaStr.slice(2);
            }
        }
    }

    closeModal() {
        //Reseteo formSucursal para eliminar errores
        this.active = false;
        setTimeout(() => this.active = true, 0);
        //Reseteo formContacto para eliminar errores
        setTimeout(() => this.active2 = false, 0);
        setTimeout(() => this.active2 = true, 0);
        //Inicializo variables
        if (this.aviso._id != undefined && this.aviso._id != "" && this.aviso._id != null)
            this.avisoService.getAviso(this.aviso._id).subscribe((aviso) => {
                for (let avisoL of this.alarma.avisosLista) {
                    if (avisoL._id == aviso._id) {
                        avisoL.nombre = aviso.nombre;
                        avisoL.lunes = aviso.lunes;
                        avisoL.martes = aviso.martes;
                        avisoL.miercoles = aviso.miercoles;
                        avisoL.jueves = aviso.jueves;
                        avisoL.viernes = aviso.viernes;
                        avisoL.sabado = aviso.sabado;
                        avisoL.domingo = aviso.domingo;
                        avisoL.usuarios = aviso.usuarios;
                        avisoL.horaDesde = aviso.horaDesde;
                        avisoL.horaHasta = aviso.horaHasta;
                        break;
                    }
                }
            });
        //Seteo bandera para deshabilitar
        this.deshabilitar = false;
        //Ocultar modal
        $("#modalAviso").modal("hide");
        $("#confirmacionAviso").modal("hide");
    }

    eliminar() {
        //Busco aviso
        this.avisoService
            .getAviso(this.aviso._id)
            .subscribe(aviso => {
                this.avisoService.delete(aviso).subscribe(
                    (aviso) => {
                        for (let avisoL of this.alarma.avisosLista) {
                            if (avisoL._id == aviso._id) {
                                avisoL.estado = aviso.estado;
                                break;
                            }
                        }
                    }
                );
                $("#confirmacionAviso").modal("hide");
            });
    }

    save() {
        //Determino operacion
        var operacion = "";
        if (this.aviso._id == "" || this.aviso._id == undefined)
            operacion = "agregar";
        else
            operacion = "modificar";
        this.aviso.sucursal_id = this.sucursal._id;

        this.avisoService
            .save(this.aviso, this.alarma)
            .subscribe((aviso) => {
                    //Inicializo variables
                    this.aviso._id = aviso._id;
                    //Actualizo listas
                    if (operacion == "agregar") {
                        if (this.alarma.avisosLista == undefined)
                            this.alarma.avisosLista = [];
                        this.alarma.avisosLista.push(aviso);
                    }
                    else
                        for (let avisoL of this.alarma.avisosLista) {
                            if (avisoL._id == aviso._id) {
                                avisoL.nombre = aviso.nombre;
                                avisoL.lunes = aviso.lunes;
                                avisoL.martes = aviso.martes;
                                avisoL.miercoles = aviso.miercoles;
                                avisoL.jueves = aviso.jueves;
                                avisoL.viernes = aviso.viernes;
                                avisoL.sabado = aviso.sabado;
                                avisoL.domingo = aviso.domingo;
                                avisoL.usuarios = aviso.usuarios;
                                avisoL.horaDesde = aviso.horaDesde;
                                avisoL.horaHasta = aviso.horaHasta;
                                break;
                            }
                        }
                    this.formatAviso();
                    //Ocultar modal
                    $("#modalAviso").modal("hide");
                    //Reseteo form para eliminar errores
                    this.active = false;
                    setTimeout(() => this.active = true, 0);
                    //Reseteo formContacto para eliminar errores
                    setTimeout(() => this.active2 = false, 0);
                    setTimeout(() => this.active2 = true, 0);
                },
                (err) => {
                })
    }


    agregarUsuario() {
        //Inicializar arreglo
        if (this.aviso.usuarios == undefined)
            this.aviso.usuarios = [];
        for (let usuario of this.usuarios) {
            if (usuario._id == this.usuario) {
                if (this.aviso.usuarios.filter(function (e) {
                        return e._id == this.usuario
                    }.bind(this)).length == 0)
                //Agregar contacto
                    this.aviso.usuarios.push(usuario);
                else
                    alert("El usuario ya esta agregado al aviso");
                break;
            }
        }

        //Limpiar contacto
        this.usuario = "";
        //Reseteo form para eliminar errores
        this.active = false;
        setTimeout(() => this.active = true, 0);
        //Reseteo formContacto para eliminar errores
        setTimeout(() => this.active2 = false, 0);
        setTimeout(() => this.active2 = true, 0);
    }

    eliminarUsuario(index) {
        //Eliminar contacto de la lista
        this.aviso.usuarios.splice(index, 1);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/aviso/aviso.component.ts